// extracted by mini-css-extract-plugin
export default {"button":"MediumButton_button__g-qWF","styleClear":"MediumButton_styleClear__qq68t","stylePrimary":"MediumButton_stylePrimary__Avg4j","styleDelete":"MediumButton_styleDelete__GWjTR"};